import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormFieldBase, FormFieldType } from 'src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { QuestionControlService } from 'src/app/core/components/dynamic-form/services/question-control.service';
import { DocumentoScansionato, protocolFields, questionsBasic, UploadFormConfiguration } from './campi';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';
import { UploadDocumentUtilityService } from './upload-document-utility.service';
import { Subscription } from 'rxjs';
import { DetailTableComponent } from './detail-table/detail-table.component';
import { SignatureDetail } from 'src/app/common/models/signature-detail';
import { OperationsService } from 'src/app/core/services/operations.service';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-document-uploaded',
  templateUrl: './document-uploaded.component.html',
  styleUrls: ['./document-uploaded.component.css']
})
export class DocumentUploadedComponent implements OnInit {
  @Input() file!: DocumentoAllegato;
  @Input() protocol: boolean = false;
  @Input() indexFile: number;
  @Input() tipiDocumentoOptions: TipoDocumento[] = null;
  @Input() nuovaVersione: boolean = false;
  deleteFileSubscription: Subscription;
  uploadForm!: FormGroup;
  canExtract: boolean = false;
  questions: FormFieldBase[] = [];
  payload:{documentiScansionati?: DocumentoScansionato[], [key:string]: any} = null;
  uploadConfig: UploadFormConfiguration = null;
  canAddDetail = false;
  uniqueSubscription: Subscription;
  documentiScansionati:DocumentoScansionato[] = [];
  iconSign: {id: string, label: string, color: string, tooltip?: string} = null;
  @ViewChild('detailTable') detailTable: DetailTableComponent;
  @Output() onRemoveFile = new EventEmitter();
  @Output() onReturn = new EventEmitter();
  invalidSignatures: SignatureDetail[] = [];
  @Output() onExtract = new EventEmitter();
  extracted: boolean = false;

  constructor(
    private qcs: QuestionControlService,
    private helperService: HelpersService,
    private utilityService: UploadDocumentUtilityService,
    private cdr: ChangeDetectorRef,
    private dialog: DialogService,
    private operationService: OperationsService
  ) {
    this.utilityService.primaryChanges.subscribe(
      value => {
        if(value === null) return;
        let index = this.questions.findIndex(x => x.key === "primary");
        if(index > -1 && this.questions[index].id !== value.id) {
           this.uploadForm.controls["primary"].setValue(false);
           let valueType = this.uploadForm.controls["type"].value;
           let tipiDocumentoOptions = [...this.tipiDocumentoOptions];
           tipiDocumentoOptions = this.tipiDocumentoOptions.filter(el => !!el.codiceAllegatoProtocollo);
           let indexVal = tipiDocumentoOptions.findIndex(x => x.label === valueType);
           if(indexVal < 0) {
            this.uploadForm.controls["type"].setValue(null);
           }
           this.setTipiDocumenti(tipiDocumentoOptions);
           this.questions[index].options = tipiDocumentoOptions;
        } else {
          this.setTipiDocumenti(this.tipiDocumentoOptions);
        }
      }
    )
    //  this.utilityService.tipoProduttoreChanges.subscribe(value => {
    //   if (!value || !this.uploadForm) return;
    //   this.uploadForm.get('tipoUfficioProduttore')?.setValue(value.value, { emitEvent: false });
    //   this.updateModalitaFormazione(value.value);
    // });
  }

  private setTipiDocumenti(tipiDocumentoOptions: TipoDocumento[]) {
    this.questions.forEach(x => {
      if (x.key === "type") {
        x.options = tipiDocumentoOptions;
      }
      x.id = (x.key + "_" + this.file.refDocumentale);
    }
    );
  }

  ngOnInit(): void {
    this.canExtract = this.acceptedContentTypes();
    this.initForm();
    this.applyDefaultTipoProduttoreAndModalita();
    // listens to primary field changes
    this.detectPrimaryFieldChanges();
    // this.detectTipoProduttoreFieldChanges();
    this.detectFormChanges();
    this.detectModeFormazioneFieldChanges();

    this.applyDefaultsForUnsigned();
    if (this.uploadConfig.hasSign) {
      const tipo = this.uploadForm.get('tipoUfficioProduttore')?.value;
      if (tipo) {
        this.uploadForm.get('tipoUfficioProduttore')!.setValue(tipo);
      }
    }
  }

  // private isTipoProduttoreSource(): boolean {
  //   if (this.protocol) {
  //     return this.uploadForm.get('primary')?.value === true;
  //   }
  //   return !this.utilityService.hasTipoProduttoreBeenInitialized();
  // }

  private applyDefaultTipoProduttoreAndModalita() {
    const tipoCtrl = this.uploadForm.get('tipoUfficioProduttore');
    const modalitaCtrl = this.uploadForm.get('modalitaFormazioneDocumento');

    if (!tipoCtrl || !modalitaCtrl) return;

    tipoCtrl.setValue('ESTERNO', { emitEvent: true });
    modalitaCtrl.setValue('A', { emitEvent: true });
  }

  private acceptedContentTypes(): boolean {
    return this.file.contentType === "message/rfc822" // eml
      || this.file.contentType === "application/zip" // zip
      || this.file.contentType === "application/vnd.rar" // rar
      || this.file.contentType === "application/x-rar" // rar
      || this.file.contentType === "application/x-rar-compressed" // RAR compresso
      || this.file.contentType === "application/x-7z-compressed" // 7zip
      || this.file.contentType === "application/mbox" // mbox
      || this.file.contentType === "application/x-mbox" // mbox
      || this.file.contentType === "application/vnd.ms-outlook"; // msg
  }

  private applyDefaultsForUnsigned() {
    // if (this.canExtract && !this.extracted) {
    //   return;
    // }

    const primaryCtrl = this.uploadForm.controls["primary"];
    if (primaryCtrl) {
      let tipiDocumentoOptions = [...this.tipiDocumentoOptions];
      // PRIMO DOCUMENTO IN PROTOCOLLO → primario = true
      
      if (this.protocol && this.indexFile === 0) {
        primaryCtrl.setValue(true, { emitEvent: true });
        this.utilityService.setPrimary({
          id: this.questions.find(q => q.key === 'primary')?.id,
          value: true
        });
      } else {
        primaryCtrl.setValue(
          this.undefinedControlProtection(this.file.primary)
        );
        tipiDocumentoOptions = this.tipiDocumentoOptions.filter(el => !!el.codiceAllegatoProtocollo);
      }

      // Aggiorna tipi documento
      
      this.setTipiDocumenti(tipiDocumentoOptions);
    }

    // Modalità formazione documento per file non firmati
    if (!this.uploadConfig.hasSign) {
      // const modalitaCtrl = this.uploadForm.get('modalitaFormazioneDocumento');
      // modalitaCtrl?.setValue('B', { emitEvent: true });
      this.uploadForm.get('motivoAssenzaFirma')?.setValue('B');
    }
  }


  private detectFormChanges() {
    this.uploadForm.valueChanges.subscribe(data => {
    let payload = this.uploadForm.getRawValue();
    const documentoUnicoCtrl = this.uploadForm.get('documentoUnico');
    if(!!documentoUnicoCtrl) {
      payload['documentoUnico'] = documentoUnicoCtrl?.value?.toLowerCase() === 'no' ? false : true;
    }
    payload["refDocumentale"] = this.file.refDocumentale;
    payload["documentiScansionati"] = this.documentiScansionati;
    this.payload = payload;
    console.log("IS VALID: ", this.uploadForm.valid)
    this.onReturn.emit(payload);
    });
  }

  private detectModeFormazioneFieldChanges() {
    this.uploadForm.get("modalitaFormazioneDocumento")?.valueChanges.subscribe( (value:string) => {
      if (this.uploadConfig.hasSign) return;
      if (this.canExtract && !this.extracted) {
        return;
      }
      if(value === 'B') {
        let index = this.questions.findIndex(x => x.key === "documentoUnico");
            // listens to unique documents field changes
          if(index === -1) {
            this.questions.push(
              {
                id: "documentoUnico_"+ this.file.refDocumentale,
                controlType: FormFieldType[FormFieldType.RADIO],
                key: "documentoUnico",
                label: "Documento Unico",
                chips: false,
                options: [
                  {id: "1_si", label: "Sì", value: "Sì"},
                  {id: "2_no", label: "No", value: "No"},
                ],
                // value: true,
                disabled: false,
                required: false,
                size: "col-sm-2"
              }
            );
            this.uploadForm.addControl('documentoUnico', new FormControl("Sì"));
            this.detectUniqueDocumentFieldChanges();
        }
      } else {
        let indexUnique = this.questions.findIndex(x => x.key === "documentoUnico");
        if(indexUnique > -1) {
          this.questions.splice(indexUnique, 1);
          this.uploadForm.removeControl('documentoUnico');
        }
        let indexNumCopie = this.questions.findIndex(x => x.key === "numDocumentiScansione");
        if(indexNumCopie > -1) {
          this.questions.splice(indexNumCopie, 1);
          this.uploadForm.removeControl('numDocumentiScansione');
        }
      }
      this.cdr.detectChanges();
    })
  }

  private detectUniqueDocumentFieldChanges() {
    this.uniqueSubscription =  this.uploadForm.get('documentoUnico').valueChanges.subscribe(value => {
      if (value.toLowerCase() === "no") {
        let index = this.questions.findIndex(x => x.key === "numDocumentiScansione");
        if(index === -1) {
          this.canAddDetail = true;
          this.questions.push(
            {
              id: "numDocumentiScansione_" + this.file.refDocumentale,
              controlType: FormFieldType[FormFieldType.NUMBER],
              key: "numDocumentiScansione",
              label: "Numero copie scansione",
              chips: false,
              // value: true,
              disabled: false,
              required: false,
              size: "col-sm-5"
            }
          );
          this.uploadForm.addControl('numDocumentiScansione', new FormControl(0));
        }
      } else {
        let index = this.questions.findIndex(x => x.key === "numDocumentiScansione");
        if(index > -1) {
          this.questions.splice(index, 1);
          this.uploadForm.removeControl('numDocumentiScansione');
        }
        this.documentiScansionati = [];
        this.payload = this.payload || {};
        this.payload.documentiScansionati = [];
        this.canAddDetail = false;
      }
      this.cdr.detectChanges();
    });
  }

  // private updateModalitaFormazione(value: string) {
  //   const modalitaCtrl = this.uploadForm.get('modalitaFormazioneDocumento');
  //   if (!modalitaCtrl) return;

  //   if (this.uploadConfig.hasSign) {
  //       // DOCUMENTI FIRMATI
  //       modalitaCtrl.setValue(value === 'INTERNO' ? 'A' : 'B');
  //       modalitaCtrl[value === 'INTERNO' ? 'disable' : 'enable']({ emitEvent: false });
  //   } else if (this.canExtract && !this.extracted) {
  //       // FILE COMPRESSI / MAIL → sempre abilitato
  //       modalitaCtrl.setValue(value === 'INTERNO' ? 'A' : 'B');
  //       modalitaCtrl.enable({ emitEvent: false });
  //   }

  //   this.cdr.detectChanges();
  // }

  private detectPrimaryFieldChanges() {
    this.uploadForm.get('primary')?.valueChanges.subscribe(value => {
      if (value === true) {
        let index = this.questions.findIndex(x => x.key === "primary");
        this.utilityService.setPrimary({ id: this.questions[index].id, value: value });
      }
    });
  }

  // private detectTipoProduttoreFieldChanges() {
  //   const tipoCtrl = this.uploadForm.get('tipoUfficioProduttore');
  //   const modalitaCtrl = this.uploadForm.get('modalitaFormazioneDocumento');

  //   if (!tipoCtrl || !modalitaCtrl) return;

  //   tipoCtrl.valueChanges.subscribe(value => {   
  //      // Aggiorno la modalita in base al tipo produttore
  //   this.updateModalitaFormazione(value);   
  //     // PROPAGAZIONE TIPO PRODUTTORE  
  //   //   if (this.isTipoProduttoreSource()) {
  //   //     this.utilityService.setTipoProduttore({
  //   //       id: this.file.refDocumentale,
  //   //       value
  //   //     });

  //   //   this.payload = {
  //   //   ...this.uploadForm.getRawValue(),
  //   //     refDocumentale: this.file.refDocumentale,
  //   //     tipoUfficioProduttore: value,
  //   //     documentiScansionati: this.documentiScansionati
  //   //   };
  //   //   this.onReturn.emit(this.payload);
        
  //   //   }
  //   //   this.utilityService.markTipoProduttoreInitialized();
  //   });
  // }


  initForm() {
    this.uploadConfig = this.utilityService.getConfiguration(this.file,this.protocol);
    this.iconSign = this.uploadConfig.icons.find(el => el.id === "validity-sign");
    if (
      this.uploadConfig.hasSign &&
      !this.uploadConfig.signValid &&
      this.file.signedData?.signerDetails?.length
    ) {
      this.invalidSignatures = this.file.signedData.signerDetails
        .filter(sig => sig.firmaValida === false);
    }
    if(this.protocol) {
      this.questions = [...protocolFields()];
    }
    this.questions = questionsBasic(this.uploadConfig.fields, this.questions);
    this.questions.forEach(x => {
        if(x.key === "type") {
          x.options = this.tipiDocumentoOptions;
        }
        x.id = (x.key + "_" + this.file.refDocumentale);
      }
    );
    this.uploadForm = this.qcs.toFormGroup(this.questions as QuestionBase[]);

    // this.uploadForm.controls["modalitaFormazioneDocumento"].disable(); // provvisorio
    
  }

  deleteFile(index) {
    this.onRemoveFile.emit({refDocumentale: this.file.refDocumentale, index: index});
  }

  undefinedControlProtection(param: boolean | undefined) {
    if(param !== undefined && param !== null) {
      return param;
    } else {
      return false;
    }
  }

  addDetail(file: DocumentoAllegato) {
    let length =  this.uploadForm.controls["numDocumentiScansione"].value;
    this.detailTable.addRow(Number(length));
  }

  onDetailChange(event) {
    this.documentiScansionati = event;
    this.payload["documentiScansionati"] = event;
    this.onReturn.emit(this.payload);
  }

  onDetaillengthChange(length:number) {
    this.uploadForm.controls["numDocumentiScansione"].setValue(length);
    this.payload["numDocumentiScansione"] = length;
  }

  extractContent(file: DocumentoAllegato) {
   this.operationService.estraiContenutoArchivio(file.refDocumentale).subscribe({
      next: (response: any) => {
          this.onExtract.emit({response: response, refDocumentale: file.refDocumentale});
          if (
            file.contentType !== 'application/zip' && // zip
            file.contentType !== 'message/rfc822' && // eml
            file.contentType !== 'application/vnd.ms-outlook' && // msg
            file.contentType !== 'application/x-rar' && // rar
            file.contentType !== 'application/vnd.rar' && // rar
            file.contentType !== 'application/x-rar-compressed' && // rar
            file.contentType !== 'application/mbox' && // mbox
            file.contentType !== 'application/x-mbox' // mbox
          ) {
            this.canAddDetail = true; 
          }
          this.questions = [];
          this.extracted = true;
          this.documentiScansionati = [];
         // this.utilityService.resetTipoProduttoreInitialized();
          this.initForm()
      },
      error: (err:any) => {
        this.openDialogEliminaDocumento(err.error);
      }
    });
  }

  openDialogEliminaDocumento(error: string) {
    const ref = this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: error,
          data: [],
          hideButtons: true,
          confirmButton :true
        },
          style: { width: "50%" },
          title: "Errore",
        }
      });
    this.deleteFileSubscription = ref.afterClosed.subscribe(event => {
      this.deleteFileSubscription.unsubscribe();
    });
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }

}
